import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportReactError } from '../services/errorReporting';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    reportReactError(error, errorInfo.componentStack ?? '');
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', padding: '32px',
          textAlign: 'center', background: 'var(--bg, #f5f5f5)',
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: 12,
            background: 'linear-gradient(135deg, #ef4444, #dc2626)',
            color: '#fff', fontSize: 28, display: 'flex',
            alignItems: 'center', justifyContent: 'center', marginBottom: 24,
          }}>
            !
          </div>
          <h1 style={{ fontSize: 24, margin: '0 0 8px', color: 'var(--ink, #333)' }}>
            Algo salio mal
          </h1>
          <p style={{ fontSize: 14, color: 'var(--ink-3, #888)', maxWidth: 400, margin: '0 0 24px' }}>
            Ocurrio un error inesperado. Por favor recargue la pagina.
            Si el problema persiste, contacte a soporte.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px', border: 'none', borderRadius: 8,
              background: 'var(--accent, #16a34a)', color: '#fff',
              fontSize: 14, fontWeight: 600, cursor: 'pointer',
            }}
          >
            Recargar pagina
          </button>
          {this.state.error && (
            <details style={{ marginTop: 24, fontSize: 12, color: '#999', maxWidth: 500, textAlign: 'left' }}>
              <summary>Detalles del error</summary>
              <pre style={{ whiteSpace: 'pre-wrap', marginTop: 8 }}>
                {this.state.error.message}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
